//LIBRERIE
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const TipologySearchSection: React.FC = () => {
    const { t } = useTranslation();

    const searchCategories = [
        {
            title: t('homePage.searchForTypo.typology1Title'),
            text: t('homePage.searchForTypo.typology1Text'),
            imgPath: "/assets/images/inHome/mare.webp",
            imageAlt: t('homePage.searchForTypo.typology1Alt'),
            link: "immobili?zone=[6,8]"
        },
        {
            title: t('homePage.searchForTypo.typology2Title'),
            text: t('homePage.searchForTypo.typology2Text'),
            imgPath: "/assets/images/inHome/campagna.webp",
            imageAlt: t('homePage.searchForTypo.typology2Alt'),
            link: "immobili?zone=[5]"
        },
        {
            title: t('homePage.searchForTypo.typology3Title'),
            text: t('homePage.searchForTypo.typology3Text'),
            imgPath: "/assets/images/inHome/montagna.webp",
            imageAlt: t('homePage.searchForTypo.typology3Alt'),
            link: "immobili?zone=[7]"
        },
        {
            title: t('homePage.searchForTypo.typology4Title'),
            text: t('homePage.searchForTypo.typology4Text'),
            imgPath: "/assets/images/inHome/citta.webp",
            imageAlt: t('homePage.searchForTypo.typology4Alt'),
            link: "immobili?zone=[9]"
        }
    ]
    
        
    return (
        <section id="searchForTipology" className="space-ptb">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 mb-4">
                        <h2>{t('homePage.searchForTypo.subTitle')}</h2>
                    </div>
                    {searchCategories.map((category, index) => (
                        <div key={index} className="col-12 col-lg-6 col-xl-3 mb-4">
                            <Link to={category.link} title={category.text}>
                                <div className="tipology-card">
                                    <h3 className="card-title" dangerouslySetInnerHTML={{ __html: category.title }}></h3>
                                    <div className="img-wrapper">
                                        <img src={category.imgPath} alt={category.imageAlt} />
                                    </div>
                                    <p dangerouslySetInnerHTML={{ __html: category.text }} className="card-text"></p>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default TipologySearchSection;
